import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';

import { jqxTreeComponent } from 'jqwidgets-ng/jqxtree';
import { jqxLoaderComponent } from 'jqwidgets-ng/jqxloader';
import { environment } from '../../../environments/environment';
import { MenuModel, MenuOptionsModel } from '../../services/sso/models/menu.model';
import { MenuService } from '../../services/menu/menu.service';
import { jqxInputComponent } from 'jqwidgets-ng/jqxinput';
import { jqxDropDownListComponent } from 'jqwidgets-ng/jqxdropdownlist';
import { MainComponent } from '../main/main.component';
import { NzModalService } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-custom-menu',
  templateUrl: './clone-menu.component.html',
  styleUrls: ['./clone-menu.component.css']
})
export class CloneMenuComponent implements OnInit, AfterViewInit {
  @ViewChild('loader') loader: jqxLoaderComponent;
  @ViewChild('menuOrigin') menuOrigin: jqxTreeComponent;
  @ViewChild('menuFinal') menuFinal: jqxTreeComponent;
  @ViewChild('ebNombre') ebNombre: jqxInputComponent;
  @ViewChild('ebObserv') ebObserv: jqxInputComponent;
  @ViewChild('cbMenuOri') cbMenuOri: jqxDropDownListComponent;

  private componentRef = null;
  public environment = environment;

  // Variables para grid y dropdownlist
  public dataSourceOri;
  public dataAdapterOri;
  public dataSourceFin;
  public dataAdapterFin;
  public accionSource;
  public accionesAdapter
  public recordsOri;
  public recordsFin;
  public menus = [];
  public menuSelecId = 0;
  public menuEdit: MenuModel = new MenuModel();

  constructor(private menuService: MenuService,
    private modal: NzModalService) {
  }

  ngOnInit(): void {
  }

  async ngAfterViewInit() {
    await this.getMenus();
    this.initMenuOri(0);
    this.initMenuFin(0);
  }

  // Este método es llamado por el creador del componente
  public init(componentRef: any) {
    this.componentRef = componentRef;
  }

  // Obtiene los menus
  async getMenus() {
    this.loader.open();
    try {
      this.menus = await this.menuService.getMenus();
      if (this.menus) {
        // Relleno el combo con los menús
        this.cbMenuOri.clear();
        this.menus.forEach((menu, i) => {
          this.cbMenuOri.addItem({ label: menu.Nombre, value: menu.Id });
        });
        this.cbMenuOri.selectIndex(0);
      }
    } catch (e) {
      console.log(e);
    }
    this.loader.close();
  }

  initMenuOri(index: number) {
    this.dataSourceOri = {
      datatype: 'json',
      datafields:
        [
          { name: 'Id', type: 'string', map: 'Id' },
          { name: 'PadreId', type: 'string', map: 'PadreId' },
          { name: 'TextoId', type: 'string', map: 'TextoId' },
          { name: 'Orden', type: 'string', map: 'Orden' },
          { name: 'AccionId', type: 'string', map: 'AccionId' }
        ],
      id: 'Id',
      localdata: this.menus[index].Opciones
    };
    this.dataAdapterOri = new jqx.dataAdapter(this.dataSourceOri, { autoBind: true });
    this.recordsOri = this.dataAdapterOri.getRecordsHierarchy('Id', 'PadreId', 'items',
      [
        { name: 'TextoId', map: 'label' },
        { name: 'AccionId', map: 'value' }
      ]);
    if (!this.recordsOri) {
      this.recordsOri = [];
    }
  }

  initMenuFin(index: number) {
    this.dataSourceFin = {
      datatype: 'json',
      datafields:
        [
          { name: 'Id', type: 'string', map: 'Id' },
          { name: 'PadreId', type: 'string', map: 'PadreId' },
          { name: 'TextoId', type: 'string', map: 'TextoId' },
          { name: 'Orden', type: 'string', map: 'Orden' },
          { name: 'AccionId', type: 'string', map: 'AccionId' }
        ],
      id: 'Id',
      localdata: this.menus[index].Opciones
    };
    this.dataAdapterFin = new jqx.dataAdapter(this.dataSourceFin, { autoBind: true });
    this.recordsFin = this.dataAdapterFin.getRecordsHierarchy('Id', 'PadreId', 'items',
      [
        { name: 'TextoId', map: 'label' },
        { name: 'AccionId', map: 'value' },
        { name: 'Id', map: 'iconsize' }
      ]);
    if (!this.recordsFin) {
      this.recordsFin = [];
    }
  }

  dragStartOrigin(event: any): void {
    // this.menuFinal.allowDrop(true);
  }

  dragEndOrigin(event: any): void {
    // this.menuFinal.allowDrop(false);
  }

  dragStartFinal(event: any): void {
  }

  dragEndFinal(event: any): void {
    for (let i = 0; this.menus.length; i++) {
      if (this.menus[i].Id === this.menuSelecId) {
        this.initMenuOri(i);
        return;
      }
    }
  }

  onChangeMenuOri(event: any) {
    const old = this.menuSelecId;
    this.menuSelecId = event.args.item.value;
    if (this.menuSelecId !== old) {
      for (let i = 0; this.menus.length; i++) {
        if (this.menus[i].Id === this.menuSelecId) {
          this.initMenuOri(i);
          this.initMenuFin(i);
          return;
        }
      }
    }
  }

  onCrear() {
    this.menuEdit.Nombre = this.ebNombre.ngValue;
    this.menuEdit.Observaciones = this.ebObserv.ngValue;
    if (!this.menuEdit.Nombre || this.menuEdit.Nombre.length < 1) {
      MainComponent.showError('ATENCIÓN', 'Introduzca un nombre', 2000);
      return;
    }
    const menuItems = this.menuFinal.getItems();
    if (menuItems && menuItems.length > 0) {
      let oldLevel = 0;
      this.menuEdit.Opciones = [];
      const orden: number[] = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
      const ids = new Map<string, number>();
      let id = 1;
      menuItems.forEach((item: any) => {
        ids.set(item.id, id++);
      });
      menuItems.forEach((item: any) => {
        const mo = new MenuOptionsModel();
        if (oldLevel < item.level) {
          orden[item.level] = 1;
        }
        mo.Id = ids.get(item.id);
        mo.MenuId = this.menuSelecId;
        mo.PadreId = item.level > 0 ? ids.get(item.parentId) : 0;
        mo.Orden = orden[item.level]++;
        mo.TextoId = item.label;
        mo.AccionId = item.value;
        mo.Observaciones = '';
        mo.OpcionOriginalId = Number.parseInt(item.iconsize); // Uso este campo para pasar el ID de la opción en el menú Base
        this.menuEdit.Opciones.push(mo);
        oldLevel = item.level;
      });
      this.modal.confirm({
        nzTitle: '<i>ATENCION</i>',
        nzContent: 'Quiere crear el menú: ' + this.menuEdit.Nombre + ' ?',
        nzCentered: true,
        nzCancelText: 'CANCELAR',
        nzOkText: 'SI',
        nzOnOk: async () => {
          // console.log(JSON.stringify(this.menuSelec, null, 4));
          if (this.menuService.saveMenu(this.menuEdit)) {
            MainComponent.showSuccess('ATENCIÓN', 'Registro almacenado', 2000);
          } else {
            MainComponent.showError('ATENCIÓN', 'Algo ha ido mal', 2000);
          }
        }
      });
    } else {
      MainComponent.showError('ATENCIÓN', 'El menú está vacio', 2000);
    }
  }

}

